import React, { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';

/**
 * FacialCaptureRedirect Component
 * 
 * Redirects from SSR form to the React SPA facial capture step.
 * This is needed because the SSR form cannot handle the MediaPipe liveness detection.
 * 
 * Receives:
 * - slug: project slug from URL params
 * - attendeeId: attendee ID from URL params (query string ?attendee=<id>)
 * 
 * Redirects to: /form/:slug?step=2&attendee=<id>
 */
const FacialCaptureRedirect = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  
  const attendeeId = searchParams.get('attendee');
  
  useEffect(() => {
    if (slug && attendeeId) {
      // Redirect to React SPA with facial capture step
      navigate(`/form/${slug}?step=2&attendee=${attendeeId}`, { replace: true });
    } else {
      // Missing params - redirect to form root
      console.warn('⚠️ [FacialCaptureRedirect] Missing params:', { slug, attendeeId });
      if (slug) {
        navigate(`/form/${slug}`, { replace: true });
      } else {
        // Neither param available, go to home
        navigate('/', { replace: true });
      }
    }
  }, [slug, attendeeId, navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-700">
      <div className="text-center">
        <div className="mb-6">
          <div className="inline-block w-16 h-16 border-4 border-t-transparent border-white rounded-full animate-spin"
               style={{ borderColor: '#ffffff', borderTopColor: 'transparent' }}></div>
        </div>
        <h2 className="text-2xl font-bold text-white mb-2">
          Redirigiendo a captura facial...
        </h2>
        <p className="text-white text-opacity-80">
          Por favor espera un momento
        </p>
      </div>
    </div>
  );
};

export default FacialCaptureRedirect;
